import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';

import { StateService, AuthService, AuctionService, MyAuctionLotService, AuctionLotService, CustomerService, SystemParametersService } from '../services';
import { AuctionLotImageModel, AuctionModel, BidRequestModel, MyAuctionLotModel, SystemParametersModel } from '../models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalViewAuctionImagesComponent } from '../auction/modals';
import { BidIncrementService } from 'src/app/services/bid-increment.service';
import { fadeAnimation } from 'src/app/shared/animations';
import { FormFunctions } from '../functions';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'auction-lot-item',
  animations: [fadeAnimation],
  template: '',
})
export class AuctionLotItemComponent implements OnInit, OnDestroy {
  processing: boolean = false;
  errorMessage: string;
  newBidAmt: number;
  oldBidAmt: number;
  NewBidAmountValidated: boolean = false;
  sysParams: SystemParametersModel = null;

  @Input() lot: any;

  @Output() bidAmountChanged = new EventEmitter<number>();
  @Output() confirmBid = new EventEmitter<number>();

  rightOfReplyInSeconds: number = 5 * 60; // 5 minutes
  placeholderImageUrl: string = 'https://media.istockphoto.com/photos/red-wine-with-property-release-picture-id157405246?b=1&amp;k=20&amp;m=157405246&amp;s=170667a&amp;w=0&amp;h=iOtNOt80hB83-HrCaRwG12cvTpiy1iE6cfLAdhd5Pt8=';

  bidMadeSubscription: Subscription;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public stateService: StateService,
    public modalService: NgbModal,
    public authService: AuthService,
    public formFunctions: FormFunctions,
    public auctionService: AuctionService,
    public auctionLotService: AuctionLotService,
    public myAuctionLotService: MyAuctionLotService,
    public bidIncrementService: BidIncrementService,
    public customerService: CustomerService,
    public systemParametersService: SystemParametersService,
  ) {
    var me = this;
  }

  ngOnInit() {
    var me = this;
    //console.log('ngOnInit', me.bidMadeSubscription);

    me.systemParametersService.Find().subscribe(data => {
      me.sysParams = data;
    })

    me.initializeRightOfReplyTimer();
    if (me.bidMadeSubscription?.closed) {
      console.warn('bidMadeSubscription is closed', me.bidMadeSubscription);
    }

    if (!me.bidMadeSubscription) {
      //console.log('bidMadeSubscription setting', me, me.lot);
      me.bidMadeSubscription = me.auctionLotService.bidMade$.subscribe(bid => {
        if (me.lot.Id == bid.Id) {
          // console.log('matching bid, updating card details', me.lot, bid);
          if (me.lot.CurrentBidDateTime < bid.CurrentBidDateTime) {
            me.lot.CurrentBid = bid.CurrentBid;
            me.lot.CurrentBidDateTime = bid.CurrentBidDateTime;
            me.lot.CurrentBidCustomerId = bid.CurrentBidCustomerId;
            me.lot.NextBid = bid.NextBid;
            me.lot.Bids = bid.Bids;
            me.lot.Bidders = bid.Bidders;
            me.lot.Watchers = bid.Watchers;
            me.ResetStatus();
            if (bid.CurrentBidCustomerId == me.customerService.customer.Id) {
              me.newBidAmt = null;
            }
          } else {
            console.warn('Attempted update is older than current data', bid.Id, me.lot.CurrentBidDateTime, bid.CurrentBidDateTime);
          }
        }
      });
    }
  }

  ngOnDestroy() {
    var me = this;
    //console.log('ngOnDestroy', me);
    me.bidMadeSubscription && me.bidMadeSubscription.unsubscribe();
  }

  Format(arr: string[]) {
    return arr.filter(Boolean).join(", ");
  }

  get UserCanPlaceBid(): boolean {
    return !this.processing && this.stateService.userModelValid() && this.LotIsBiddable;
  }

  get Auction(): AuctionModel {
    return this.auctionService.auctions.find(x => x.Id == this.lot.AuctionId);
  }

  get LotIsBiddable(): boolean {
    if (!this.AuctionIsOpen) return false; // if not Open
    if (!this.AuctionHasExpired) return true; // normal operating times
    // Otherwise in right of reply mode
    if (!this.CustomerHasRightOfReply) return false;
    return true;
  }

  get AuctionIsOpen(): boolean {
    // return this.Auction?.AuctionStatusId === 1;
    let isOpenStatus = this.Auction?.AuctionStatusId === 1;
    let isOpenDate = this.Auction?.OpenDate < new Date();
    // debugger;
    return isOpenStatus && isOpenDate;
  }

  get AuctionHasExpired(): boolean {
    return this.Auction?.CloseDate < new Date();
  }

  get CustomerHasRightOfReply(): boolean {
    if (!this.MyAuctionLot?.BidDate) return false; // User must have made at least one bid to have right of reply
    var rightOfReplyTimer = this.RightOfReplyTimer;
    return rightOfReplyTimer >= 0;
  }

  timer;
  RightOfReplyTimer: number;
  initializeRightOfReplyTimer() {
    let me = this;
    me.RightOfReplyTimer = me.CalculateRightOfReplyTimer();
    me.timer = setInterval(function () {
      me.RightOfReplyTimer = me.CalculateRightOfReplyTimer();
    }, 1000);
  }

  CalculateRightOfReplyTimer(): number {
    var expires = this.RightOfReplyExpiry;
    //console.log('Right', expires, new Date().getTime(), expires.getTime());
    return Math.round((expires.getTime() - new Date().getTime()) / 1000);
  }

  get RightOfReplyExpiry(): Date {
    // Cannot include CloseDate as a possible date as if it is already closed and within 5 minutes of close, all lots with a bid get a 5 minute right of reply, which is incorrect.
    // var possibleDates = [this.lot?.CurrentBidDateTime, this.Auction?.CloseDate];

    // 2 minutes longer than right of reply, before auction ends, stops null errors
    var secondDate = new Date(this.Auction?.CloseDate.getTime() - ((this.rightOfReplyInSeconds + 120) * 1000));
    var possibleDates = [this.lot?.CurrentBidDateTime, secondDate];
    let latestDate: Date = null;
    possibleDates.forEach(date => {
      if (date && date > latestDate) {
        latestDate = date;
      }
    });
    var latestBidDate = latestDate;
    var expires = new Date(latestBidDate.getTime() + (this.rightOfReplyInSeconds * 1000));
    if (this.lot?.LotNumber == 7) {
      // debugger;
    }
    return expires;
  }

  get Status(): string {
    return this.IsWinning ? 'Winning' : this.IsOutbid ? 'Outbid' : '';
  }

  get MyAuctionLot(): MyAuctionLotModel {
    return this.myAuctionLotService.myAuctionLots.find(x => x.AuctionLotId == this.lot.Id);
  }

  get IsWinning(): boolean {
    return this.stateService.userModel && this.MyAuctionLot && !this.MyAuctionLot?.WatchingOnly && this.MyAuctionLot?.IsWinning;
  }

  get IsOutbid(): boolean {
    return this.stateService.userModel && this.MyAuctionLot && !this.MyAuctionLot?.WatchingOnly && !this.MyAuctionLot?.IsWinning;
  }

  get MinimumBid(): number {
    if (this.IsWinning) {
      return this.MyAuctionLot.MinimumNextBid;
    } else {
      return this.lot?.NextBid ? this.lot?.NextBid : this.lot?.ReservePrice || this.lot?.EstimatePrice;
    }
  }

  get NewBidIsValid(): boolean {
    return this.newBidAmt && this.newBidAmt >= this.MinimumBid;
  }

  get BuyerPremium(): number {
    let defaultPremium = this.sysParams ? this.sysParams.BuyerPremium : 0.165;
    return this.lot.BuyerPremiumOverride || this.customerService.customer?.BuyerPremium || defaultPremium; // TODO: load final default from SystemParameters
  }

  get ItemPrice(): number {
    return this.newBidAmt || this.lot.CurrentBid;
  }

  get SubTotal(): number {
    return this.lot.Quantity * this.ItemPrice;
  }

  get PremiumTotal(): number {
    return this.BuyerPremium * this.SubTotal;
  }

  get Total(): number {
    return this.SubTotal + this.PremiumTotal;
  }

  /**
  * Reset the UI status after a bid update is received
  */
  ResetStatus() {
    let me = this;
    //me.newBidAmt = null;
    me.errorMessage = null;
  }

  FavouriteItem(event, lot) {
    let me = this;

    me.processing = true;
    if (me.MyAuctionLot) {
      lot.Watchers--;
      me.auctionLotService.RemoveFromWatchList(lot.Id).subscribe((data) => {
        //me.myAuctionLotService.RemoveFromWatchList([lot.Id]).subscribe((data) => {
        // console.log('Removed from watch list');
        me.myAuctionLotService.UpdateList();
        me.processing = false;
        // setTimeout(_ => {
        //   me.myAuctionLotService.UpdateList();
        //   me.processing = false;
        // }, 1000)
      });
    }
    else {
      lot.Watchers++;
      //me.myAuctionLotService.myAuctionLots.splice(me.myAuctionLotService.myAuctionLots.findIndex(x => x.Id == lot.Id), 1);
      me.auctionLotService.AddToWatchList(lot.Id).subscribe((data) => {
        //me.myAuctionLotService.AddToWatchList([lot.Id]).subscribe((data) => {
        // console.log('Added to watch list');
        me.myAuctionLotService.UpdateList();
        me.processing = false;
        // setTimeout(_ => {
        //   me.myAuctionLotService.UpdateList();
        //   me.processing = false;
        // }, 1000)
      });
    }
  }

  get Images(): AuctionLotImageModel[] {
    return this.lot?.AuctionLotImages.map(x => Object.assign(new AuctionLotImageModel(), x));
  }

  ViewImages() {
    let me = this;
    const modalRef = me.modalService.open(ModalViewAuctionImagesComponent, {
      scrollable: true,
      size: 'lg'
    });
    // console.log(this.Images);
    modalRef.componentInstance.images = this.Images;
  }

  get IsSelected(): boolean {
    return this.newBidAmt > 0 && this.LotIsBiddable;
  }

  ConfirmBid($event) {
    let me = this;
    // console.log('ConfirmBid', $event, me.newBidAmt);
    me.confirmBid?.next(me.newBidAmt);
  }

  AdjustToIncrement(): Promise<void> {
    let me = this;
    //console.log('AdjustToIncrement.start', me.NewBidAmountValidated);
    //me.NewBidAmountValidated = false;
    me.oldBidAmt = null;
    if (!me.NewBidAmountValidated && me.NewBidIsValid && !me.bidIncrementService.IsKnownValid(me.newBidAmt)) {
      me.processing = true;
      return me.bidIncrementService.AdjustToIncrement(me.newBidAmt).toPromise().then(data => {
        // console.log('AdjustToIncrement', me.newBidAmt, data.DecimalValue);
        let oldVal = me.newBidAmt;
        me.newBidAmt = data.DecimalValue;
        // Only set 'old' value if it's actually different and has been adjusted
        me.oldBidAmt = null;
        if (me.newBidAmt != oldVal) {
          me.oldBidAmt = oldVal;
        }
        me.NewBidAmountValidated = true;
        me.processing = false;
      });
    } else {
      return Promise.resolve();
    }
  }
}